module.exports = __webpack_public_path__ + "static/img/ht2.3871f91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ht2.jpg
// module id = W/0n
// module chunks = 1